<ng-container *ngIf="items.length">
  <div *ngIf="variant === 'icons'" class="flex items-center gap-1">
    <span *ngFor="let item of items; trackBy: trackByCode" class="amenity-dot" [title]="item.label"
      [attr.aria-label]="item.label">
      <span class="material-symbols-outlined">{{ item.icon }}</span>
    </span>
    <span *ngIf="hiddenCount > 0" class="amenity-dot amenity-more">+{{ hiddenCount }}</span>
  </div>

  <div *ngIf="variant === 'chips'" class="flex flex-wrap gap-1.5">
    <span *ngFor="let item of items; trackBy: trackByCode" class="amenity-chip">
      <span class="material-symbols-outlined">{{ item.icon }}</span>
      <span>{{ item.label }}<ng-container *ngIf="item.note"> · {{ item.note }}</ng-container></span>
    </span>
    <span *ngIf="hiddenCount > 0" class="amenity-chip amenity-more">+{{ hiddenCount }}</span>
  </div>

  <div *ngIf="variant === 'grid'" class="grid grid-cols-2 gap-2">
    <div *ngFor="let item of items; trackBy: trackByCode" class="amenity-tile">
      <span class="amenity-tile-icon">
        <span class="material-symbols-outlined">{{ item.icon }}</span>
      </span>
      <span class="min-w-0">
        <span class="block text-xs font-bold text-slate-800 leading-tight">{{ item.label }}</span>
        <span *ngIf="item.note" class="block text-[10px] text-slate-500 mt-0.5 truncate">{{ item.note }}</span>
      </span>
    </div>
  </div>
</ng-container>
